"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.routes = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const system_login_1 = require("./system-login");
const set_new_password_1 = require("./set-new-password");
exports.routes = [
    {
        path: "/login",
        element: (0, jsx_runtime_1.jsx)(system_login_1.SystemLogin, {}),
    },
    {
        path: "/set-new-password",
        element: (0, jsx_runtime_1.jsx)(set_new_password_1.SetNewPassword, {}),
    },
];
//# sourceMappingURL=routes.js.map